import { PublishCourse } from "../publishCourse"

export const PublishOnboarding = ({ publish, pageSwap }) => {
    return(
        <PublishCourse
            pageSwap={pageSwap}
            customerStage={2}
        />

    )
}